module.exports = __webpack_public_path__ + "img/E-WEB-Goal-05.9da33cf4.png";